// import'./bootstrap');
import '../demo1/tools/webpack/vendors/global';
import '../demo1/tools/webpack/scripts';
import 'parsleyjs';
import 'inputmask';

import JSZip from 'jszip';
// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import 'datatables.net';
// import 'datatables.net-bs4';
// import 'datatables.net-responsive-bs4';
// import 'datatables.net-select-bs4';
// import 'datatables.net-buttons-bs4';
// import 'datatables.net-autofill-bs4';
// import 'datatables.net-buttons/js/buttons.html5';
// import 'datatables.net-buttons/js/buttons.colVis';
// import 'datatables.net-buttons/js/buttons.flash';
// import 'datatables.net-buttons/js/buttons.print';
// import 'datatables.net-colreorder-bs4';
// import 'datatables.net-fixedcolumns-bs4';
// import 'datatables.net-fixedheader-bs4';
// import 'datatables.net-keytable-bs4';
// import 'datatables.net-rowgroup-bs4';
// import 'datatables.net-rowreorder-bs4';
// import 'datatables.net-scroller-bs4';
// import 'datatables.net-searchpanes-bs4';
import '../../public/vendor/core/core';

import 'lightgallery.js/dist/js/lightgallery';

window.JSZip = JSZip;
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
